module.exports = __webpack_public_path__ + "static/media/carDate.4dec2c90.png";